/**
 * Configuration for API host.
 * Local dev: Uses REACT_APP_HOST from .env.local (e.g., http://localhost:5004)
 * Production: Empty string, API calls become relative paths handled by Azure
 */
const config = {
  REACT_APP_HOST: process.env.REACT_APP_HOST || "",
  REACT_APP_STATUS_API_URL: "https://status.elion.be/api",
  REACT_APP_DASH_URL: "https://dashboard.elion.be/installer/login",
  REACT_APP_STATUS_URL: "https://status.elion.be"
};

export default config;
